var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 6,
    viewBox: "0 0 24 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7824 5.54902C22.116 5.54902 23.197 4.46794 23.197 3.13437C23.197 1.8008 22.116 0.719727 20.7824 0.719727C19.4488 0.719727 18.3677 1.8008 18.3677 3.13437C18.3677 4.46794 19.4488 5.54902 20.7824 5.54902Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5903 5.48554C12.9239 5.48554 14.005 4.40447 14.005 3.0709C14.005 1.73732 12.9239 0.65625 11.5903 0.65625C10.2567 0.65625 9.17566 1.73732 9.17566 3.0709C9.17566 4.40447 10.2567 5.48554 11.5903 5.48554Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41465 5.48554C3.74822 5.48554 4.82929 4.40447 4.82929 3.0709C4.82929 1.73732 3.74822 0.65625 2.41465 0.65625C1.08107 0.65625 0 1.73732 0 3.0709C0 4.40447 1.08107 5.48554 2.41465 5.48554Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableDot);
export default __webpack_public_path__ + "static/media/tableDot.6e606df41fde7d15ba4e0a12e78c649d.svg";
export { ForwardRef as ReactComponent };